import * as React from 'react';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

type containerDescriptionProps = {
    contentLink: string,
    containerSize: string,
    trashType: string,
    selectedImage: string,
    translations: any
};

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function fetchContainerDescription(contentLink: string) {
    return new Promise<{
        title: string,
        containerDescription: string,
        containerDimensions: string,
        containerImage: string,
        trashTypeTitle: string,
        trashTypeDescription: string,
        prohibitedTypesOfLitterTitle: string
        prohibitedTypesOfLitter: string,
    }>((resolve, reject) => {
        const options = {
            method: 'GET',
        };

        fetch(contentLink, options)
            .then((res) => res.json())
            .then(({
                       title,
                       containerDescription,
                       containerDimensions,
                       containerImage,
                       trashTypeTitle,
                       trashTypeDescription,
                       prohibitedTypesOfLitterTitle,
                       prohibitedTypesOfLitter
                   }) => {
                resolve({
                    title,
                    containerDescription,
                    containerDimensions,
                    containerImage,
                    trashTypeTitle,
                    trashTypeDescription,
                    prohibitedTypesOfLitterTitle,
                    prohibitedTypesOfLitter
                });
            });
    });
}

export const ContainerDescription = (
    {
        contentLink,
        containerSize,
        trashType,
        selectedImage,
        translations
    }: containerDescriptionProps
) => {
    const [open, setOpen] = React.useState(false);
    const requestAbortController = React.useRef<AbortController | null>(null);
    const [title, setTitle] = React.useState('');
    const [containerDescription, setContainerDescription] = React.useState('');
    const [containerDimensions, setContainerDimensions] = React.useState('');
    const [prohibitedTypesOfLitter, setProhibitedTypesOfLitter] = React.useState('');
    const [prohibitedTypesOfLitterTitle, setProhibitedTypesOfLitterTitle] = React.useState('');
    const [containerImage, setContainerImage] = React.useState('');
    const [trashTypeTitle, setTrashTypeTitle] = React.useState('');
    const [trashTypeDescription, setTrashTypeDescription] = React.useState('');
    const [showButton, setShowButton] = React.useState(false);

    const handleClickOpen = () => {
        if (containerSize != '' && trashType != '') {
            setOpen(true);
        }
    };
    const handleClose = () => {
        setOpen(false);
    };

    const fetchContainerDescriptionByLink = (contentLink: string) => {
        const controller = new AbortController();
        fetchContainerDescription(contentLink)
            .then(({
                       title,
                       containerDescription,
                       containerDimensions,
                       containerImage,
                       trashTypeTitle,
                       trashTypeDescription,
                       prohibitedTypesOfLitterTitle,
                       prohibitedTypesOfLitter
                   }) => {
                setTitle(title);
                setContainerDescription(containerDescription);
                setContainerDimensions(containerDimensions);
                setContainerImage(containerImage);
                setTrashTypeTitle(trashTypeTitle);
                setTrashTypeDescription(trashTypeDescription);
                setProhibitedTypesOfLitterTitle(prohibitedTypesOfLitterTitle);
                setProhibitedTypesOfLitter(prohibitedTypesOfLitter);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    throw error;
                }
            });

        requestAbortController.current = controller;
    };

    React.useEffect(() => {
        if (containerSize != '' && trashType != '') {
            fetchContainerDescriptionByLink(contentLink.concat('/', containerSize, '/', trashType));
            setShowButton(true);
        } else {
            setShowButton(false);
        }
        return () => requestAbortController.current?.abort();
    }, [containerSize, trashType]);

    return (
        <>
            {showButton && <span className={'more-about-container'} onClick={handleClickOpen}>
                <span>{translations.more_about_container}</span>
            </span>
            }
            <img src={selectedImage} height="100%"/>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{m: 0, p: 2}} id="customized-dialog-title">
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        <span className="container-description-image"><img src={containerImage}
                                                                           alt={'containerImg'}/></span>
                        <span className="container-dimensions" dangerouslySetInnerHTML={{__html: containerDimensions}}/>
                        <span dangerouslySetInnerHTML={{__html: containerDescription}}/>
                        <span className="trashTypeTitle" dangerouslySetInnerHTML={{__html: trashTypeTitle}}/>
                        <span dangerouslySetInnerHTML={{__html: trashTypeDescription}}/>
                        <span className="prohibitedTypesOfLitter">
                              <strong>{prohibitedTypesOfLitterTitle}</strong><br/>
                            {prohibitedTypesOfLitter}
                        </span>
                    </Typography>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
